import React, { useEffect, useState } from "react";
import clsx from "clsx";
import QalortButton from "./Button";
import team from "../assets/team.svg";
import eye from "../assets/eye.svg";
import link from "../assets/link.svg";
import { getInitials } from "../utils/stringHelpers";
import { RightHeaderComponent } from "./menu/Header";
import JoinMeetinButton from "./JoinMeetinButton";
import { Link } from "react-router-dom";
import { GetCohortAttendees } from "../services/cohortService";
import Modal from "antd/lib/modal";
import useEnableJoinBtn from "../hooks/useEnableJoinBtn";
import CopyToClipboard from "react-copy-to-clipboard";
import { notification, Tooltip } from "antd";

const CohortDetails = ({ currentCohort, onChangeTab, defaultTab }) => {
  const [whatTab, setWhatTab] = useState(defaultTab || "Posts");
  const [attendees, setAttendees] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { disableJoinBtn } = useEnableJoinBtn(currentCohort);

  const getAtendees = async () => {
    setAttendees([]);
    try {
      const res = await GetCohortAttendees(currentCohort?.id);
      setAttendees(res.data.data || []);
    } catch (error) {
      setAttendees([]);
    }
  };

  useEffect(() => {
    getAtendees();
  }, [currentCohort]);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <div className="h-[170px] py-4">
      <div className="px-4">
        <div
          className={`h-[100px] w-full bg-cover bg-center rounded-md`}
          style={{ backgroundImage: `url(${currentCohort?.banner})` }}
        ></div>
      </div>
      <div className="grid grid-cols-[1fr_250px] [@media(max-width:1086px)]:grid-cols-2  mt-2 px-4 border-b border-[#ECEBF5]">
        <div className="flex items-center [@media(max-width:1086px)]:flex-wrap">
          <div className="flex [@media(max-width:1086px)]:pt-2 items-center">
            <div className="w-[28px] h-[28px] text-[12px] text-[#30307D] font-semibold bg-[#EFEFFE] rounded-[6px] flex items-center justify-center uppercase">
              {getInitials(currentCohort?.title)}
            </div>
            <p className="text-[14px] text-[#30307D] font-medium m-0 pl-2 mr-4 max-w-[280px] one-liner">
              {currentCohort?.title}
            </p>
          </div>

          <div className="flex [@media(max-width:1086px)]:pt-2">
            {["Post", "Attachment", "Recordings"].map((item, index) => (
              <button
                key={index}
                onClick={() => {
                  setWhatTab(item);
                  onChangeTab(item);
                }}
                className={clsx(
                  "h-[40px] px-2 border-0 border-b text-[#535393] border-transparent text-[12x] flex items-center justify-center font-medium",
                  {
                    "border-b-2 border-pri pri": whatTab === item,
                  }
                )}
              >
                {item}
              </button>
            ))}
          </div>
        </div>
        <div className="w-[250px] flex gap-2 justify-self-end justify-end [@media(max-width:1086px)]:w-[100px]">
          <Tooltip
            title={<p className="text-main">Join Session</p>}
            trigger="hover"
            placement="bottomLeft"
          >
            <JoinMeetinButton
              type="primary"
              className="!h-[30px] !text-[14px] !px-4"
              meetingInfo={currentCohort}
              disabled={disableJoinBtn}
            >
              Join
            </JoinMeetinButton>
          </Tooltip>
          <div className="flex gap-2 [@media(max-width:1086px)]:hidden">
            <Tooltip
              title={<p className="text-main">View cohort members</p>}
              placement="bottomLeft"
            >
              <button
                className="border border-[#DCDCE9] rounded-[6px] bg-[#F9F9FF] h-[30px] w-[50px] flex items-center justify-center text-[12px] text-[#30307D] disabled:opacity-50 disabled:cursor-not-allowed"
                onClick={showModal}
              >
                <img src={team} className="mr-1" alt="" /> {attendees.length}
              </button>
            </Tooltip>
            <Tooltip
              title={<p className="text-main">Preview cohort details</p>}
              placement="bottomLeft"
            >
              <Link to={`/ct/${currentCohort?.slug}`}>
                <button className="border border-[#DCDCE9] rounded-[6px] bg-[#F9F9FF] h-[30px] w-[30px] flex items-center justify-center text-[12px] text-[#30307D]">
                  <img src={eye} alt="" />
                </button>
              </Link>
            </Tooltip>

            <CopyToClipboard
              text={`${window.location.origin}/ct/${currentCohort?.slug}`}
              onCopy={() =>
                notification.success({
                  description: `link copied!`,
                })
              }
            >
              <Tooltip
                title={<p className="text-main">Share cohort link</p>}
                placement="bottomLeft"
              >
                <button className="border border-[#DCDCE9] rounded-[6px] bg-[#F9F9FF] h-[30px] w-[30px] flex items-center justify-center text-[12px] text-[#30307D]">
                  <img src={link} alt=""></img>
                </button>
              </Tooltip>
            </CopyToClipboard>
          </div>
        </div>
      </div>

      <Modal
        width={400}
        title={
          <div className="flex items-center">
            <div className="w-[28px] h-[28px] text-[12px] text-[#30307D] font-semibold bg-[#EFEFFE] rounded-[6px] flex items-center justify-center uppercase">
              {getInitials(currentCohort?.title)}
            </div>
            <p className="text-[14px] text-[#30307D] font-medium m-0 pl-2 mr-4 max-w-[280px] one-liner">
              {currentCohort?.title}
            </p>
          </div>
        }
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
      >
        <p className="font-medium text-[#535393] mb-1">Description</p>
        <p className="mb-4 text-[#7575A8] text-[12px]">
          {currentCohort?.description}
        </p>
        <div className="border-t pt-4 mt-4 border-[#ECEBF5] mb-4">
          <p className="text-[#535393]">Members ({attendees.length})</p>
          <ul>
            {attendees.map((attendee, index) => (
              <li
                key={index}
                className="mb-2 flex items-center text-[#30307D] text-[12px] capitalize"
              >
                <img
                  src={attendee.user.profile}
                  className="w-[30px] h-[30px] rounded-full mr-2"
                  alt=""
                />
                {attendee.user.name}
              </li>
            ))}
          </ul>
        </div>
      </Modal>
    </div>
  );
};

export default CohortDetails;
